const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "60px",
    width: "60px",
    id: "Layer_1",
    viewBox: "0 0 509.2 509.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254.4,
    cy: 254.6,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M458.4,180.6c0,0-64.8-12-102.8-3.6c0,0-44.8,4.4-57.2,0.4c0,0-30.8-7.6-32.4,40.4  c0,0-9.6,95.6,12.4,90.4l11.6,8.4c0,0,8,25.2,26.4,19.6c0,0,22.4,16.8,30.8-18c0,0,6-12.8,50.4-15.6c0,0,37.2-10.4,42-17.2  c0,0,15.6,4,31.2-11.6c0,0,8.4-6.8,36.8,8c0.8-8.8,1.6-18,1.6-26.8c0-25.6-4-50.4-10.8-73.6C487.6,180.2,471.2,178.6,458.4,180.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M326.8,235c-10-3.6-26.8-29.2-26.8-29.2s5.6,14.8,14.8,22.8c0,0-14.4-7.6-14-9.2c0,0,3.6,6.8,9.6,10   c0,0,5.2,4.4,8.8,3.2c0,0-0.8,13.6-13.2,15.6c0,0-9.2,0.4-15.6-3.2c0,0,8.4,8.8,12,8.4c0,0-2,7.2,2.4,9.6c0,0-18,7.6-23.2,22.8   c0,0,12.4-16,24-18.8c0,0,14.4-5.2,10.4,12.4c0,0,4.8-4,0.4-14c0,0-9.2-6.4,3.2-22.8c0,0,20.4-10.4,10,20c0,0,10-8.8,4.8-21.2   C334.4,241,334.4,237.4,326.8,235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M318.8,279.8c-10-0.4-20.8,14.8-20.8,14.8c-7.6,13.2-19.6,13.6-19.6,13.6l11.6,8.4c0,0,0.8,2,2,5.2   c0-4,0.4-7.6,0.4-7.6c2.4-22,26-31.6,26-31.6c7.2-4.4,8-15.6,8-15.6C324.8,274.6,318.8,279.8,318.8,279.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M508.4,260.2c-8.4-1.6-15.6-2-21.6-1.2c0,0-2.8-10.8,19.6-16.4c0,0-38.4-5.2-62,32.4   c0,0-13.6-0.4-22,10.8c0,0,8.8-16.8,6-22.4c0,0-4.8,22-26.8,26c0,0,7.2-14.8,4.4-20.8c0,0-2.8,13.6-9.6,18.4l-5.2-3.6   c0,0-10,21.6-41.2,23.2c0,0-24.4,12-34.4,29.6c1.2,0.8,22.8,16,30.8-18c0,0,6-12.8,50.4-15.6c0,0,37.2-10.4,42-17.2   c0,0,15.6,4,31.2-11.6c0,0,8.4-6.8,36.8,8c0.4-2.8,0.4-5.6,0.8-8c-0.8,0-1.2-0.4-2-0.4c0,0,0.8,0,2,0.4   C508,269,508,264.6,508.4,260.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M217.6,195.8c-12.8,3.2-57.2-4-57.2-4C123.2,181,57.6,189,57.6,189c-19.2-4.4-47.6-1.6-47.6-1.6  s-0.4,0-0.8,0C3.2,209,0,231.4,0,255c0,10.8,0.8,21.2,2,32c29.6-13.2,37.6-6,37.6-6C54.4,297.8,70,294.6,70,294.6  c4.4,6.8,40.8,19.6,40.8,19.6c44,5.6,49.2,18.8,49.2,18.8c6.4,35.2,29.6,20,29.6,20c18,6.8,27.6-17.6,27.6-17.6l12-7.6  c22,6.8,18.4-89.2,18.4-89.2C248.8,189.8,217.6,195.8,217.6,195.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M185.6,251c10.4-2.8,28.4-27.6,28.4-27.6s-6.8,14.4-16.4,22c0,0,14.8-6.8,14.8-8.4   c0,0-4,6.8-10.4,9.2c0,0-5.6,4-8.8,2.4c0,0,0,13.6,12.4,16.4c0,0,9.2,1.2,15.6-2.4c0,0-8.8,8.4-12.4,7.6c0,0,1.6,7.6-3.2,9.6   c0,0,17.6,8.8,22,24.4c0,0-11.2-16.8-22.8-20c0,0-14-6-11.2,12c0,0-4.4-4.4,0.4-14c0,0,9.6-6-2-22.8c0,0-19.6-11.6-11.2,19.2   c0,0-9.6-9.6-3.6-21.6C177.6,256.6,178,253.4,185.6,251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M190.8,296.6c10,0.4,20,16.4,20,16.4c6.4,13.2,18.8,14.4,18.8,14.4l-12,7.6c0,0-0.8,2-2.4,4.8   c0.4-4,0.4-7.6,0.4-7.6c-1.2-22-24-32.8-24-32.8c-6.8-4.8-6.8-16-6.8-16C184.8,291,190.8,296.6,190.8,296.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M157.6,321c-30.8-3.6-39.6-25.6-39.6-25.6l-5.2,3.2c-6.4-5.2-8.4-18.8-8.4-18.8   c-3.2,6,3.2,21.2,3.2,21.2c-21.6-5.6-24.8-28-24.8-28c-3.2,5.6,4.4,22.8,4.4,22.8c-7.6-12-21.2-12.4-21.2-12.4   c-21.2-38.8-60-36-60-36c22,7.2,18.4,17.6,18.4,17.6c-6.4-1.6-14.8-1.2-24,0c0,4.4,0.4,8.4,0.8,12.8c2-0.4,2.8-0.4,2.8-0.4   c-1.2,0-2,0.4-2.8,0.8c0.4,2.8,0.4,5.2,0.8,8c29.6-13.2,37.6-6,37.6-6C54.4,297,70,293.8,70,293.8c4.4,6.8,40.8,19.6,40.8,19.6   c44,5.6,49.2,18.8,49.2,18.8c6,34.4,28.8,20.4,29.6,20C180.8,334.6,157.6,321,157.6,321z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMma);
export default __webpack_public_path__ + "static/media/mma.5c0230bef444fd750a08e5c0ccd1b285.svg";
export { ForwardRef as ReactComponent };